import { render, staticRenderFns } from "./LegacyTask.vue?vue&type=template&id=91e26304&"
import script from "./LegacyTask.vue?vue&type=script&lang=js&"
export * from "./LegacyTask.vue?vue&type=script&lang=js&"
import style0 from "./LegacyTask.vue?vue&type=style&index=0&id=91e26304&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports